/* @ngInject */

export default (
  $q,
  $rootScope,
  helperService,
  helperPdfService,
  signaturesPdfService
) => {
  /**
         * Prepare acknowledgement and declaration for New Zealand's home loan.
         *
         * @param {Object} ticketOwner
         * @param {Boolean} pageBreak

         * @returns {Array}
         */
  const prepareAcknowledgementAndDeclarationForHomeLoanNZ = ({ ticketOwner, pageBreak }) => {
    const content = [];
    if (!pageBreak) {
      content.push({
        text: '',
        margin: [0, 10, 0, 0]
      });
    }
    content.push(
      helperPdfService.createHeader({
        title: 'ACKNOWLEDGEMENT AND DECLARATION',
        pageBreak: pageBreak || ''
      })
    );
    content.push({
      columns: [
        [
          { text: `Introducer: ${ticketOwner.getName()}`, style: 'marginTop' },
          {
            columns: [
              {
                width: 20,
                canvas: [
                  {
                    type: 'rect',
                    x: 0,
                    y: 1,
                    w: 9,
                    h: 9,
                    r: 0,
                    lineColor: 'black'
                  }
                ]
              },
              { text: 'By ticking this box, I/we confirm the following:' }
            ],
            style: 'marginTop'
          },
          { text: 'Receiving your authority to act', bold: true, style: 'marginTop' },
          {
            ul: [
              {
                text:
                  'I/we give the Adviser express authority to act on my/our behalf with all lenders, product providers and associated parties (“Loan Parties”) in respect of assessing eligibility for a home loan or other finance (“home loan finance”), and/or risk products associated with my/our application.'
              },
              {
                text:
                  'I/we understand that the Adviser will not charge me/us for these services, unless specifically agreed in writing in advance, but will receive a commission from the lender providing the loan (“the Lender”).'
              },
              {
                text:
                  'I/we also understand that the Adviser is not an employee, agent, partner, nor joint venture partner of, nor does the Adviser act on behalf of, the Lender or the Loan Parties.'
              }
            ]
          },
          { text: 'Use of your Personal Information', bold: true, style: 'marginTop' },
          {
            ul: [
              {
                text:
                  'I/we give the Adviser express authority to act on my/our behalf with all lenders, product providers and associated parties (“Loan Parties”) in respect of assessing eligibility for a home loan or other finance (“home loan finance”), and/or risk products associated with my/our application.'
              },
              {
                ul: [
                  {
                    text: 'verifying my/our identity and address'
                  },
                  {
                    text:
                      'checking that I/we meet credit criteria and other eligibility requirements'
                  },
                  {
                    text: 'managing the relationship with me/us'
                  },
                  {
                    text:
                      'providing it to any number of Loan Parties required for the purpose of securing or attempting to secure home loan finance'
                  },
                  {
                    text: `providing it to ${ticketOwner.user.licenses.in1}’s mortgage aggregator, ${ticketOwner.user.licenses.in2}, to assist with any investigation into any complaint made by a client, Loan Parties or a regulatory body`
                  },
                  {
                    text:
                      'if my/our application is successful, administering the home loan and any ongoing commission payments to the Adviser'
                  },
                  {
                    text:
                      'complying with applicable laws and rules, including anti-money laundering and countering financing of terrorism legislation'
                  },
                  {
                    text: 'market research'
                  },
                  {
                    text:
                      'notifying me/us either by physical notice or by electronic means of products or services that may be of interest to me/us'
                  }
                ]
              },
              {
                text: `I/we consent to the Adviser, ${ticketOwner.user.licenses.in1}, ${ticketOwner.user.licenses.in2} and the Loan Parties disclosing my/our Personal Information to, and obtaining from, credit reporting and government agencies, other credit providers and insurers, personal information about me/us for these purposes.`
              },
              {
                text:
                  'I/we acknowledge that all Personal Information will be held by the Adviser at the address below, and that I/we may seek access to, and correction of, the Personal Information in accordance with the Privacy Act 1993.'
              },
              {
                text:
                  'I/we understand that I/we are not required by law to provide any Personal Information to the Adviser but any failure to do so might prejudice any chances of obtaining finance.'
              }
            ]
          },
          {
            text: 'Collection and disclosure of your Personal Information',
            bold: true,
            style: 'marginTop'
          },
          {
            ul: [
              {
                text:
                  'I/We authorise the Adviser, the Loan Parties and the Recipients to collect Personal Information about me/us from third parties including, but not restricted to, credit reporting and government agencies, banks and employers, and for those third parties to disclose information to the Adviser, the Lender and the Recipients.'
              },
              {
                text:
                  'I/We authorise the Lender to disclose my/our Personal Information to the Adviser during the term of the loan in order to answer my queries or assist me with my financial arrangements as my/our circumstances change.'
              },
              {
                text: `I/We authorise and direct the Adviser, the Lender and the Recipients to provide my Personal Information to ${ticketOwner.user.licenses.in1}.`
              },
              {
                text: `I/We authorise and direct the Adviser to, at the request of ${ticketOwner.user.licenses.in1}, transfer all information and files held by the Adviser to ${ticketOwner.user.licenses.in1} should the Adviser cease to be a contracted adviser of ${ticketOwner.user.licenses.in1}.`
              },
              {
                text:
                  'I/We acknowledge that the Financial Markets Authority or any other relevant Regulator may ask to see my file and that the adviser will provide that file upon appropriate written request.'
              }
            ]
          },
          {
            text: 'Credit reporting agencies',
            bold: true,
            style: 'marginTop'
          },
          {
            ul: [
              {
                text:
                  'The Adviser, the Lender and the Recipients to disclose my/our Personal Information to credit reporting agencies and also to any third party making an authorised enquiry about me/us.'
              },
              {
                text:
                  'The credit reporting agencies of the Adviser, the Lender and the Recipients to hold my/our Personal Information on their systems and to use my personal information held on their systems to provide credit reporting services.'
              },
              {
                text:
                  'The credit reporting agencies of the Adviser, the Lender and the Recipients to provide my Personal Information to its customers using their credit reporting services.'
              },
              {
                text:
                  'The Adviser, the Lender and the Recipients to use the services of their credit reporting agencies in future for the purposes related to the provision of my/our home loan and/or any other credit to me/us. This authorisation shall include the use of any monitoring services to receive updates about me/us if any of the Personal Information held about me changes.'
              },
              {
                text:
                  'The Adviser, the Lender and the Recipients to give information to credit reporting agencies about my/our default in any payment obligations.'
              },
              {
                text:
                  'The credit reporting agencies of the Adviser, the Lender and the Recipients to provide information about my default in any payment obligations to other customers of the credit reporting agencies.'
              }
            ]
          },
          {
            text: 'Lender’s Mortgage Insurer’s use of your Personal Information',
            bold: true,
            style: 'marginTop'
          },
          {
            ul: [
              {
                text:
                  'I/we accept that the Lender will, from time to time, make the Personal Information available to the Lender’s mortgage insurer (if any), any person with whom the Lender proposes to enter into contractual arrangements, any security or trustee, and any assignee or potential assignee of the Lender’s rights (“the Recipients”).'
              }
            ]
          },
          {
            text: 'Commission arrangements',
            bold: true,
            style: 'marginTop'
          },
          {
            ul: [
              {
                text: `If the Adviser has an arrangement with the Lender that the Lender will pay ongoing commission over the term of the loan, I/we understand that the Lender will periodically disclose my/our loan balance to the Adviser. I/we also authorise the Adviser and ${ticketOwner.user.licenses.in1} to have all rights of continuing access to my/our client files and/or information held by the Lender.`
              },
              {
                text:
                  'I/we understand and acknowledge that any fee charged by the Adviser for services relating to this loan application has been disclosed to me/us and that it only relates to services provided by the Adviser and is not in any way associated with services provided by the Lender.'
              }
            ]
          }
        ]
      ],
      style: ['value']
    });
    content.push({
      text: '',
      margin: [0, 20, 0, 0]
    });
    content.push(
      helperPdfService.createSubHeader({
        title: 'GST MATTERS'
      })
    );
    content.push({
      columns: [
        [
          { text: 'I/we confirm that: (select those applicable)', style: 'marginTop' },
          {
            columns: [
              {
                width: 20,
                canvas: [
                  {
                    type: 'rect',
                    x: 0,
                    y: 1,
                    w: 9,
                    h: 9,
                    r: 0,
                    lineColor: 'black'
                  }
                ]
              },
              {
                text:
                  'I/we am/are not registered for GST and will not be with respect to the security property.'
              }
            ],
            style: 'marginTop'
          },
          {
            columns: [
              {
                width: 20,
                canvas: [
                  {
                    type: 'rect',
                    x: 0,
                    y: 1,
                    w: 9,
                    h: 9,
                    r: 0,
                    lineColor: 'black'
                  }
                ]
              },
              {
                text:
                  'I/we am/are or will be registered for GST, but the security property will be/will not be used for the purpose of a taxable activity'
              }
            ],
            style: 'marginTop'
          }
        ]
      ],
      style: ['value']
    });
    content.push(
      helperPdfService.createSubHeader({
        title: 'OPTIONAL CONFIRMATIONS'
      })
    );
    content.push({
      columns: [
        [
          { text: 'I/we confirm that: (select those applicable)', style: 'marginTop' },
          {
            columns: [
              {
                width: 20,
                canvas: [
                  {
                    type: 'rect',
                    x: 0,
                    y: 1,
                    w: 9,
                    h: 9,
                    r: 0,
                    lineColor: 'black'
                  }
                ]
              },
              {
                text:
                  'I/we consent to the Adviser referring me/us and my/our Personal Information, including details relating to my/our personal risk insurance requirements, to a specialist insurance adviser for a review of my/our personal risk insurance requirements.'
              }
            ],
            style: 'marginTop'
          },
          {
            columns: [
              {
                width: 20,
                canvas: [
                  {
                    type: 'rect',
                    x: 0,
                    y: 1,
                    w: 9,
                    h: 9,
                    r: 0,
                    lineColor: 'black'
                  }
                ]
              },
              {
                text:
                  'I/We am/are aware that should we repay this loan that has been arranged by the Adviser within 27 months of drawing down the loan, the adviser may (at their sole discretion) require I/we to repay the amount of the commission clawed back by the lender/provider'
              }
            ],
            style: 'marginTop'
          }
        ]
      ],
      style: ['value']
    });
    content.push(
      helperPdfService.createSubHeader({
        title: 'MANDATORY CONFIRMATIONS'
      })
    );
    content.push({
      columns: [
        [
          {
            text:
              'I/we confirm and declare to the Adviser, the Lender and the Recipients, each of the following:',
            style: 'marginTop'
          },
          {
            columns: [
              {
                width: 20,
                canvas: [
                  {
                    type: 'rect',
                    x: 0,
                    y: 1,
                    w: 9,
                    h: 9,
                    r: 0,
                    lineColor: 'black'
                  }
                ]
              },
              {
                text:
                  'The information contained in the application is true and correct and I/We have not withheld any information which would be of concern or interest to a Lender'
              }
            ],
            style: 'marginTop'
          },
          {
            columns: [
              {
                width: 20,
                canvas: [
                  {
                    type: 'rect',
                    x: 0,
                    y: 1,
                    w: 9,
                    h: 9,
                    r: 0,
                    lineColor: 'black'
                  }
                ]
              },
              {
                text: 'I/we am/are to meet legal and valuation costs;'
              }
            ],
            style: 'marginTop'
          },
          {
            columns: [
              {
                width: 20,
                canvas: [
                  {
                    type: 'rect',
                    x: 0,
                    y: 1,
                    w: 9,
                    h: 9,
                    r: 0,
                    lineColor: 'black'
                  }
                ]
              },
              {
                text:
                  'I/We am/are not and have never been a bankrupt or subject to proceedings under the Insolvency Act 1967;'
              }
            ],
            style: 'marginTop'
          },
          {
            columns: [
              {
                width: 20,
                canvas: [
                  {
                    type: 'rect',
                    x: 0,
                    y: 1,
                    w: 9,
                    h: 9,
                    r: 0,
                    lineColor: 'black'
                  }
                ]
              },
              {
                text:
                  'I/we acknowledge that the Adviser needs to rely upon the information provided by me/us in order to arrange the finance requested, and agree to indemnify and keep indemnified the Adviser in relation to any liability, claims, damages, costs (legal or otherwise) and losses whatsoever resulting from, or in relation to, any information provided or implied by me/us in relation to this application and the home loan services.  This clause is to survive the expiration or termination of this document.'
              }
            ],
            style: 'marginTop'
          },
          {
            columns: [
              {
                width: 20,
                canvas: [
                  {
                    type: 'rect',
                    x: 0,
                    y: 1,
                    w: 9,
                    h: 9,
                    r: 0,
                    lineColor: 'black'
                  }
                ]
              },
              {
                text:
                  'I/we understand that should my circumstances change before I/we have repaid the full amount owing on any home loan that is entered into as a result of this application, I/we am/are responsible for continuing to make home loan repayments despite those changed circumstances. In the event of my death, I understand that it will be my estate’s responsibility to make my home loan repayments and/or to pay off any loan balance.'
              }
            ],
            style: 'marginTop'
          },
          {
            columns: [
              {
                width: 20,
                canvas: [
                  {
                    type: 'rect',
                    x: 0,
                    y: 1,
                    w: 9,
                    h: 9,
                    r: 0,
                    lineColor: 'black'
                  }
                ]
              },
              {
                text:
                  'I acknowledge that when I have made this application jointly with another person, our liability under this application will be joint and several.'
              }
            ],
            style: 'marginTop'
          },
          {
            columns: [
              {
                width: 20,
                canvas: [
                  {
                    type: 'rect',
                    x: 0,
                    y: 1,
                    w: 9,
                    h: 9,
                    r: 0,
                    lineColor: 'black'
                  }
                ]
              },
              {
                text: `I acknowledge that I have been provided with a copy of the Adviser’s Disclosure Statement - Version ${ticketOwner.user.licenses.in6} - Dated ${ticketOwner.user.licenses.id6}`
              }
            ],
            style: 'marginTop'
          }
        ]
      ],
      style: ['value']
    });
    return content;
  };

  /**
   * Prepare acknowledgement and declaration.
   *
   * @param {Array} contacts
   * @param {Object} ticketOwner
   * @param {Object} workflow
   * @param {Boolean} pageBreak
   *
   * @returns {Array}
   */
  const prepareAcknowledgementAndDeclaration = ({
    contacts,
    contactLabels,
    ticket,
    ticketOwner,
    workflow,
    pageBreak
  }) => {
    const content = [];
    if (workflow?.isHomeLoan() && helperService.getOrganizationCountry().cca2 === 'NZ') {
      content.push(
        prepareAcknowledgementAndDeclarationForHomeLoanNZ({ ticketOwner, pageBreak })
      );
      content.push(
        signaturesPdfService.prepareSignaturesDetails({
          contacts,
          contactLabels,
          ticket,
          ticketOwner,
          pageBreak: 'before',
          showIntroducer: false
        })
      );
    }
    return content;
  };

  return {
    prepareAcknowledgementAndDeclaration
  };
};
